module.exports = __webpack_public_path__ + "zvetseni-prsou_11_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_11_before.jpg
// module id = 1296
// module chunks = 0